export const socialsData = {
    github: 'https://github.com/Talha-74',
    // facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/talha-khan74/',
    // instagram: 'https://www.instagram.com/',
    codepen: 'https://codepen.io/Talha_shinwari',
    twitter: 'https://twitter.com/TalhaCode',
    // reddit: 'https://www.reddit.com/user/',
    // medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/22933706/talha-khan',
    // youtube: 'https://youtube.com/'
}